// extracted by mini-css-extract-plugin
export default {"NirInput":"NirInput_NirInput__OcmBM"};